module.exports = __webpack_public_path__ + "static/media/bin.7ace881c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/bin.png
// module id = 2437
// module chunks = 0